import ActivityLogsList from './ActivityLogsList';

export default ActivityLogsList;
